import { createDataWidget } from "@/widgets/common/createDataWidget";
import { fetchDashboardMockData } from "../mockDashboard";
import { mapRateOfOperationToPoints } from "./logic";
import type { RunningStatusSharePoint } from "./types";

/**
 * Widget state via the shared factory (D11): thunk + slice + selectors in
 * one declaration. The fetcher reads the `rate_of_operation` section from
 * the page's dashboard response and zips it into per-day rows; swapping in
 * CubeJS is a body-only change here.
 */
export const runningStatusShareChart = createDataWidget<RunningStatusSharePoint>({
  name: "runningStatusShareChart",
  fetcher: async () => {
    const response = await fetchDashboardMockData();
    return mapRateOfOperationToPoints(response.data.rate_of_operation);
  },
});
